import {Component} from 'react';
import userPermissionsEditorShape from '../userPermissionsEditorShape';
import UserPermissionDisplay from '../UserPermissionDisplay/UserPermissionDisplay';
import lodash from 'lodash';
import styles from './UserList.scss';

export class UserList extends Component {

    static sortRenderableUsers(renderableUsers, sortedListOfSubs) {
        return lodash.sortBy(renderableUsers,
            (u1, u2) => sortedListOfSubs.indexOf(u1 && u1.sub) - sortedListOfSubs.indexOf(u2 && u2.sub));
    }

    handleSelectAll(e) {
        e.preventDefault();
        this.props.changeSelection('all');
    }

    handleSelectNone(e) {
        e.preventDefault();
        this.props.changeSelection('none');
    }

    render() {
        const {
            users,
            sortedUsers,
            visibleUsers,
            selectedUsers,
            updatedUsers,
            groups,
            permissionProperties,
            clearSelection,
            changeSelection,
            viewAllUsers,
            viewSummaryMode,
        } = this.props;

        const renderableUsers = lodash.filter(users, u => {
            if (viewAllUsers === 'out') {
                const hasAccess = lodash.some(u.binderPermissions,
                    bp => bp.name === 'hasBinderAccess' && bp.value === 'yes');
                return !visibleUsers.includes(u.sub) || !hasAccess;
            } else if (viewAllUsers === 'in') {
                const hasAccess = lodash.some(u.binderPermissions,
                    bp => bp.name === 'hasBinderAccess' && bp.value === 'yes');
                return visibleUsers.includes(u.sub) && hasAccess;
            } else {
                return visibleUsers.includes(u.sub);
            }
        });
        const sortedRenderableUsers = UserList.sortRenderableUsers(renderableUsers, sortedUsers);

        const renderedUsers = lodash.map(sortedRenderableUsers,
            u => <UserPermissionDisplay user={u}
                key={u.sub}
                groups={groups}
                clearSelection={clearSelection}
                changeSelection={changeSelection}
                isSelected={selectedUsers.includes(u.sub)}
                isUpdated={updatedUsers.includes(u.sub)}
                viewSummaryMode={viewSummaryMode}
                permissionProperties={permissionProperties}/>);

        const userSelectionMessage = `${selectedUsers.length} of ${renderedUsers.length} selected.`;
        const selectionInstructions = 'Click on user to select. Click again to remove.';

        return (
            <div className={styles.userList} data-cy="UserList">
                <div className={styles.userSummaryArea}>
                    <span className={styles.userSummaryMessage} data-cy="UserList-userSummaryMessage">{userSelectionMessage}</span>
                    <span className={styles.userSummaryInstructions} data-cy="UserList-userSummaryInstructions">{selectionInstructions}</span>
                    <span className={styles.userSummaryActionLinkArea}>
                        <span className={styles.userSummaryActionLink}>
                            <a href="#" onClick={this.handleSelectAll.bind(this)} data-cy="UserList-handleSelectAll">Select&nbsp;All</a>
                        </span>
                        <span className={styles.userSummaryActionLinkSeparator}>|</span>
                        <span className={styles.userSummaryActionLink}>
                            <a href="#" onClick={this.handleSelectNone.bind(this)} data-cy="UserList-handleSelectNone">Unselect&nbsp;All</a>
                        </span>
                    </span>
                </div>
                <div className={styles.userScrollingArea} data-cy="UserList-renderedUsers">
                    {renderedUsers}
                </div>
            </div>
        );
    }
}

UserList.propTypes = userPermissionsEditorShape;

export default UserList;
